// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  addIssuesToProjectPickerBulkByQueryMutation,
  UpdateIssuesBulkByQueryInput,
} from './__generated__/addIssuesToProjectPickerBulkByQueryMutation.graphql'

type addToProjectUpdateArgs = {
  addToProjectV2Ids: string[]
  removeFromProjectV2Ids: string[]
}

export function commitAddIssuesToProjectPickerBulkByQueryMutation({
  environment,
  input: {query, repositoryId, addToProjectV2Ids, removeFromProjectV2Ids},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {query: string; repositoryId: string} & addToProjectUpdateArgs
  onCompleted?: (response: addIssuesToProjectPickerBulkByQueryMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {addToProjectV2Ids, removeFromProjectV2Ids}
  const inputHash: UpdateIssuesBulkByQueryInput = {
    query,
    repositoryId,
    ...inputArgs,
  }

  return commitMutation<addIssuesToProjectPickerBulkByQueryMutation>(environment, {
    mutation: graphql`
      mutation addIssuesToProjectPickerBulkByQueryMutation($input: UpdateIssuesBulkByQueryInput!) @raw_response_type {
        updateIssuesBulkByQuery(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
